const config = {
  columns: [
    {
      dataIndex: 'orgId',
      hidden: true,
    },
    {
      title: '序号',
      width: 80,
      render: 'numberRender',
    },
    {
      title: '报价类型',
      dataIndex: 'quoteTypeName',
      width: 150,
    },
    {
      title: '所属类目',
      dataIndex: 'categoryTypeName',
      width: 150,
    },
    {
      title: '费用项',
      dataIndex: 'itemName',
      width: 150,
    },
    {
      title: '操作',
      fixed: 'right',
      width: 100,
      render: 'actionTool',
    },
  ],
  search: [
    {
      name: 'quoteType',
      label: '报价类型',
      data: 'budgetList',
      itemType: 'select',
      labelKey: 'name',
      key: 'code',
    },
  ],
  footer: [
    { label: '下载导入模板', render: 'downloadRender' },
    { label: '批量导入', render: 'importRender' },
    { label: '导出', render: 'exportRender' },
    { label: '添加配置', type: 'primary', events: ['onClick:addConfig'] },
  ],
  batchActions: [
    {
      label: '批量删除',
      danger: true,
      events: ['onClick:batchDelete'],
    },
  ],
}

export default config
